import { TextField } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import React, { FC } from "react";
import { isWholeNumberUnit, normalizeQuantity } from "./reporting-quantity.helper";

const useStyles = makeStyles()({
  input: {
    width: "120px",
    "& input": {
      textAlign: "right",
    },
  },
});

interface IPomReportingTableQuantityColumnProps {
  positionNo: number;
  currentQuantity: number;
  editedQuantity: number | undefined;
  unit: string | undefined;
  disabled: boolean;
  onQuantityChange: (positionNo: number, quantity: number) => void;
}

export const PomReportingTableQuantityColumn: FC<IPomReportingTableQuantityColumnProps> = (props) => {
  const { positionNo, currentQuantity, editedQuantity, unit, disabled, onQuantityChange } = props;
  const { classes } = useStyles();

  // Snapping here instead of in onChange would rewrite the controlled input mid-typing and move the caret
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const parsed = parseFloat(event.target.value);
    if (!isNaN(parsed) && parsed >= 0) {
      onQuantityChange(positionNo, parsed);
    }
  };

  // Snap only what the user typed: blurring an untouched field must not file a rounded BC quantity
  const handleBlur = (): void => {
    if (editedQuantity === undefined) {
      return;
    }
    const normalized = normalizeQuantity(editedQuantity, unit);
    if (normalized !== editedQuantity) {
      onQuantityChange(positionNo, normalized);
    }
  };

  return (
    <TextField
      className={classes.input}
      type="number"
      variant="outlined"
      size="small"
      value={editedQuantity !== undefined ? editedQuantity : currentQuantity}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      // "any" keeps typed thousandths valid while the spinner arrows still move by a visible whole unit
      inputProps={{ min: 0, step: isWholeNumberUnit(unit) ? 1 : "any" }}
    />
  );
};
